import './index.css';
import Tiptap from './components/Tiptap';
import { FormikFunction } from './components/SidePanel/formik-function/formik-function';
import ExportModal from './components/SettingsPopover/exportModal';
import { useProject } from './components/projectContext';

const Editor = ({ blogPost }) => {
  const { open: exportOpen, setOpen: setExportOpen } = useProject();

  return (
    <>
      <FormikFunction blogPost={blogPost}>
        <Tiptap />
      </FormikFunction>
      {/* <ExportModal open={exportOpen} setOpen={setExportOpen} /> */}
    </>
  );
};

export default Editor;
